export default __webpack_public_path__ + "static/media/new-search.0f16c410.svg";